import { render } from "./TermEntryField.vue?vue&type=template&id=3bfb0844&scoped=true"
import script from "./TermEntryField.vue?vue&type=script&lang=js"
export * from "./TermEntryField.vue?vue&type=script&lang=js"

import "./TermEntryField.vue?vue&type=style&index=0&id=3bfb0844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfb0844"]])

export default __exports__